import { render, staticRenderFns } from "./StaleRequestReport.vue?vue&type=template&id=d80d1e0a"
import script from "./StaleRequestReport.vue?vue&type=script&lang=js"
export * from "./StaleRequestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports